import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { AssetProtectionGoalImpacts } from './repository';
import { AssetProtectionGoalImpact } from './entity';
import { type AssetProtectionGoalImpactData } from './dto';

export class AssetProtectionGoalImpactsCommands
    implements
        Commands<
            AssetProtectionGoalImpacts,
            AssetProtectionGoalImpact,
            AssetProtectionGoalImpactData
        >
{
    addAll(
        repo: AssetProtectionGoalImpacts,
        data: AssetProtectionGoalImpactData[],
    ): AssetProtectionGoalImpacts {
        data.forEach((assetProtectionGoalImpactData) => {
            this.add(repo, assetProtectionGoalImpactData);
        });
        return repo;
    }

    add(
        repo: AssetProtectionGoalImpacts,
        data: AssetProtectionGoalImpactData,
    ): AssetProtectionGoalImpacts {
        const assetProtectionGoalImpact = new AssetProtectionGoalImpact({
            ...data,
        });
        repo.add(assetProtectionGoalImpact);
        return repo;
    }

    update(
        repo: AssetProtectionGoalImpacts,
        entity: AssetProtectionGoalImpact,
    ): AssetProtectionGoalImpact {
        repo.update(entity);
        return entity;
    }

    remove(repo: AssetProtectionGoalImpacts, id: string): void {
        repo.remove(id);
    }

    create(
        repo: AssetProtectionGoalImpacts,
        data: Omit<AssetProtectionGoalImpactData, 'id'>,
    ): AssetProtectionGoalImpact {
        const uuid = new UUID();
        const assetProtectionGoalImpact = new AssetProtectionGoalImpact({
            id: uuid.toString(),
            ...data,
        });
        repo.add(assetProtectionGoalImpact);
        return assetProtectionGoalImpact;
    }

    fromJSON(
        entity: AssetProtectionGoalImpact[],
        changeCallback: () => void,
    ): AssetProtectionGoalImpacts {
        const newAssetProtectionGoalImpacts = new AssetProtectionGoalImpacts(
            changeCallback,
        );
        entity.forEach((assetProtectionGoalImpact) => {
            newAssetProtectionGoalImpacts.add(
                new AssetProtectionGoalImpact({
                    ...assetProtectionGoalImpact,
                }),
            );
        });
        return newAssetProtectionGoalImpacts;
    }
}
